<template>
  <div id="app">
    <router-view />

  </div>
</template>

<script>
  import axios from 'axios';
  import {
    Toast
  } from 'vant';

  export default {
    name: 'App',
    data() {
      return {
        isZjzwfw: false // 是否对接浙里办
      }
    },
    mounted() {
      if (this.isZjzwfw) {
        common.removeSession('ticket');
        common.removeSession('name');
        common.removeSession('idcard');
        this.handelTicket();
      } else {
        // 判断用户是否登录
        // this.handleUserAuth();

        //用过验证token，判断登录状态是否失效
        this.checkLogin();
      }
    },
    destroyed() {

    },
    methods: {
      handelTicket() {

        let url = window.location.href;
        // url = 'http://wzslwqyljk.yyhj.zjzwfw.gov.cn/?1=1&ticket=8a11885a72bde1fa0172fdf6fcbd3c21-ticket';
        let result = common.parseURL(url);
        let ticket = result.params.ticket;

        if (ticket) {
          Toast.loading({
            message: '请稍等',
            duration: 0,
            forbidClick: true
          });
          common.setSession('ticket', ticket);
          axios({
              method: 'get',
              baseURL: 'http://122.228.182.58:8097/pjrz?st=' + ticket,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
            }).then(function(response) {
              Toast.clear();
              let res = response.data.body.response;
              console.log(res)
              if (res.ret_code === '0') {
                // alert(JSON.stringify(res))
                common.setSession('name', res.datas.username)
                common.setSession('idcard', res.datas.idnum)
                // alert('name:'+common.getSession('name'))
                // alert('idcard:'+common.getSession('idcard'))

                // let port = result.port.length > 0 ? ':' + result.port : '';
                // let protocol = result.protocol + '://';
                // window.location.replace(protocol + result.host + port + '/#/home');
                return;
              } else {
                Toast.fail(res.ret_info)
                return;
              }
            })
            .catch(function(error) {
              Toast.clear();
              Toast.fail(error)
            });

          // common.ajax({
          //   transNO: 'zjzw',
          //   params: {st: ticket},
          //   method: 'get'
          // }).then(res => {
          //   console.log(res)
          // }).catch(er => {
          //
          // })
        }


      },
      // 判断用户是否登录
      handleUserAuth() {
        if (common.getSession('token') == null || common.getSession('userId') == null) {
          this.$router.replace('Login')
        } else if (!common.getSession('userInfo')) {
          this.$router.replace('ChangeInfo')
        }
      },
      checkLogin() {
        let token = common.getStorage('token');
        if (!token) {
          this.$router.replace({
            path: 'Login'
          })
        }
        common.ajax({
            transNO: 'verifyToken',
            params: {
              token: common.getStorage('token')
            },
            toast: true
          })
          .then(res => {
            // console.log(res);
            this.handleUserInfo();
          }).catch(ex => {
            //如果token已失效，则跳转至登录页面
            common.removeStorage('userId')
            common.removeStorage('token');

            common.removeSession('userInfo');

            // console.log('ex', ex)
            this.$router.replace({
              path: 'Login'
            })
          });
      },
      handleUserInfo() {
        common.ajax({
          method: 'get',
          transNO: 'getUserInfo',
          params: {}
        }).then(res => {
          //判断用户信息是否完善，未完善用户直接跳转至完善信息页面
          console.log(res)
          if (!res.data.name) {
            this.$router.replace({
              path: 'ChangeInfo'
            })
          } else {
            common.setSession('userInfo', res.data);
						common.setSession('name',res.data.name);
						common.setSession('idcard',res.data.idcard);
          }

        })
      },
    }
  }
</script>

<style lang="scss">
  /*@import '../static/fonts/font.css';*/
  @import '../static/style/common';
</style>



// WEBPACK FOOTER //
// src/App.vue